import { FC } from 'react';
import { TextBlock } from './TextBlock';

export interface GuestCounterProps {
  /** Number of elapsed seconds */
  remainingSeconds: number | null;
  onClick: () => void;
}

export const GuestCounter: FC<GuestCounterProps> = ({ remainingSeconds, ...rest }) => {
  const validRemainingSeconds = remainingSeconds ?? 0;
  const minutes = Math.floor(validRemainingSeconds / 60);
  const seconds = validRemainingSeconds % 60;

  return (
    <TextBlock {...rest}>
      {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
    </TextBlock>
  );
};
